import { ArrowUpRight, BookOpen, Images, Star } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="ki-seccion" aria-label={seccion.titulo}>
      <div className="ki-seccion-interior">
        <EncabezadoSeccion p="ki" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ki-titulo-enlaces" />
        <Reveal>
          <div className="ki-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="ki-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`ki-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={2} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "ki-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "ki-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="ki-seccion" aria-label={seccion.titulo}>
      <div className="ki-seccion-interior">
        <EncabezadoSeccion p="ki" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ki-titulo-accesos" />
        <Reveal>
          <div className="ki-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="ki-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={2} />
                <span>
                  <span className="ki-acceso-titulo">{item.datos.titulo}</span>
                  <span className="ki-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="ki"
        textos={[protagonista.nombre, `${protagonista.edad} ${protagonista.textoEdad || "años"}`, evento.fechaCorta, evento.ciudad]}
      />
      <section className="ki-seccion ki-cierre" data-testid="ki-cierre">
        <div className="ki-seccion-interior">
          <Reveal>
            <Star className="ki-cierre-estrella" strokeWidth={1.8} fill="currentColor" aria-hidden="true" />
            <p className="ki-cierre-mensaje">{protagonista.mensajeCierre}</p>
            <p className="ki-cierre-nombre">{protagonista.nombre}</p>
            <div className="ki-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="ki-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="ki-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
